import type { BoxId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface FitGraphToViewCommand {
  boxId?: BoxId;
}

export const fitGraphToView: GraphCommandFactory<
  FitGraphToViewCommand | undefined
> = (cmdContext) => (command) => {
  cmdContext.eventEmitter.emit('fitGraphToView', { boxId: command?.boxId });
};
